import { ResourceTypeInfoNames } from '@agilelab/plugin-wb-governance-common';
import { governanceApiRef } from '../plugin';
import { identityApiRef, useApi } from '@mainstage/core-plugin-api';
import { useQuery } from '@tanstack/react-query';

type Props = {
  filters?: {
    name?: string;
  };
};

export const useResourceTypesApi = (props: Props) => {
  const governanceApi = useApi(governanceApiRef);
  const identityApi = useApi(identityApiRef);

  const { error, isLoading, data } = useQuery<
    Map<string, ResourceTypeInfoNames>,
    Error
  >({
    queryKey: ['resourceTypes', props?.filters?.name],
    queryFn: async () => {
      const response = await governanceApi.getAllResourceTypes(
        await identityApi.getCredentials(),
      );

      return response.resourceTypes
        .filter(
          resourceType =>
            !props?.filters?.name || resourceType.name === props?.filters?.name,
        )
        .reduce((typesMap, resourceType) => {
          typesMap.set(resourceType.name, {
            name: resourceType.name,
            displayName: resourceType.displayName,
          });
          return typesMap;
        }, new Map<string, ResourceTypeInfoNames>());
    },
  });

  return {
    resourceTypesError: error,
    resourceTypesLoading: isLoading,
    resourceTypes: data,
  };
};
